import React from "react"
import PropTypes from "prop-types"
import SocialNetworks from "components/social-networks/social-networks"
import Menu from "components/styled/theme-menu"
import { Link } from "gatsby"
import Logo from "components/logo/logo"
import styled from "styled-components"
import SearchBox from "@bufox/flex-search-box/flex-search-box"
import themeConfig from "utils/theme-config"
const { screens } = themeConfig

const Header = props => {
  const {
    className,
    homepageUri,
    location,
    primaryMenu,
    searchSettings,
    searchUrls,
    siteDescription,
    siteTitle,
    socialNetworks,
    translationsMenu,
  } = props

  return (
    <header className={className}>
      <div className="header-menu-container">
        {primaryMenu && (
          <Menu
            className="dry-container main-menu"
            currentUrl={location?.href}
            featured
            host={location?.origin}
            linkComponent={Link}
            mobileAuxiliaryMenu={translationsMenu}
            mobileFeaturedComponent={
              <SearchBox
                className="mobile-search-box"
                indexUrl={searchUrls.indexUrl}
                {...searchSettings}
                storeUrl={searchUrls.storeUrl}
              ></SearchBox>
            }
            path="/"
            primaryMenu={primaryMenu}
          />
        )}
      </div>
      <div className="header-sections dry-container">
        <div className="header-section-1">
          <Logo
            className="logo"
            siteTitle={siteTitle}
            siteDescription={siteDescription}
            path={homepageUri}
          ></Logo>
        </div>
        <div className="header-section-2">
          <div>
            <SearchBox
              className="desktop-search-box"
              indexUrl={searchUrls.indexUrl}
              searchPlaceholder={
                searchSettings?.searchPlaceholder
                  ? searchSettings.searchPlaceholder
                  : ""
              }
              storeUrl={searchUrls.storeUrl}
            ></SearchBox>
          </div>
          {socialNetworks ? (
            <div className="social-networks-bar">
              <SocialNetworks socialNetworks={socialNetworks}></SocialNetworks>
            </div>
          ) : null}
          {translationsMenu?.length ? (
            <div className="translations-desktop">
              {
                <ul>
                  {translationsMenu.map(el => (
                    <li
                      className="translations-element"
                      key={`translation-${el.language.code}`}
                    >
                      <Link to={el.uri}>{el.language.code}</Link>
                    </li>
                  ))}
                </ul>
              }
            </div>
          ) : null}
        </div>
      </div>
    </header>
  )
}

Header.propTypes = {
  className: PropTypes.string,
  homepageUri: PropTypes.string,
  location: PropTypes.object,
  primaryMenu: PropTypes.array,
  siteDescription: PropTypes.string,
  searchSettings: PropTypes.object,
  searchUrls: PropTypes.object,
  siteTitle: PropTypes.string,
  socialNetworks: PropTypes.object,
  translationsMenu: PropTypes.array,
}

Header.defaultProps = {}

const StyledHeader = styled(Header)`
  .header-menu-container {
    background-color: var(--primary);
  }

  .header-sections {
    padding: 6rem 1rem 2rem 1rem;
    margin-left: auto;
    margin-right: auto;
  }

  .header-section-2 {
    display: flex;
    justify-content: center;
    margin-top: 1rem /* 16px */;
    margin-bottom: 1rem /* 16px */;
  }

  .translations-element {
    &:after {
      position: absolute;
      background: var(--secondary);
      width: 2px;
      content: "";
      height: 1rem;
      margin-top: auto;
      margin-bottom: auto;
      top: 0;
      bottom: 0;
      right: 0;
    }
    &:last-child {
      &:after {
        display: none;
      }
    }
    & > a {
      color: var(--primary);
      transition: color 500ms ease-out;
      &:hover {
        color: var(--tertiary);
      }
    }
  }

  .mobile-search-box {
    z-index: 20;
    padding-left: 1rem;
  }

  .desktop-search-box {
    display: none;
  }

  .social-networks-bar {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--primary);
  }

  .translations-desktop {
    display: none;
  }

  @media only screen and (min-width: ${screens.sm}) {
  }
  // Medium screens
  @media only screen and (min-width: ${screens.md}) {
  }
  // Large screens
  @media only screen and (min-width: ${screens.lg}) {
    display: flex;
    flex-direction: column;
    .header-menu-container {
      order: 2;
    }
    .header-sections {
      display: flex;
      justify-content: space-between;
      align-items: center;
      order: 1;
      padding-top: 2rem;
      padding-bottom: 2rem;
    }
    .header-section-1 {
      max-width: 41.66%;
    }
    .header-section-2 {
      max-width: 58.33%;
      align-items: center;
      justify-content: flex-end;
      flex-wrap: wrap;
    }

    .desktop-search-box {
      display: block;
      position: relative;
      z-index: 20;
      margin-left: 1rem;
      margin-right: 1rem;
    }
    .social-networks-bar {
      margin-left: 1rem;
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
      justify-content: flex-end;
    }
    .translations-desktop {
      display: flex;
      justify-content: space-between;
      margin-left: 1rem;
      height: 100%;
      align-items: center;
      ul {
        display: flex;
      }
      .translations-element {
        position: relative;
        padding-left: 0.5rem /* 8px */;
        padding-right: 0.5rem /* 8px */;
      }
    }
  }
  // Extra Large screens
  @media only screen and (min-width: ${screens.xl}) {
  }
  // Wider screens
  @media only screen and (min-width: ${screens["2xl"]}) {
  }
`

StyledHeader.defaultProps = {
  smScreen: "640px",
  mdScreen: "768px",
  lgScreen: "1024px",
  xlScreen: "1280px",
  "2xlScreen": "1536px",
}
export default StyledHeader
export { Header }
